// extracted by mini-css-extract-plugin
export default {"tile-badge":"similar-to-you7s8P9c","tile-badge__label":"similar-to-youtozIgC","tile-badge__label--super-offer":"similar-to-youIfpYPI"};